const hourFormatter = (hour: string) => hour.slice(0, 2) + ':' + hour.slice(-2);

export default hourFormatter;
